import { LoadableLazy } from '@confluence/loadable';

export const RecentsEmptyStateLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RecentsEmptyState" */
				'../components/RecentsEmptyState.tsx'
			)
		).RecentsEmptyState,
});
